import {ActionHandler} from "../../../infrastructure/handlers/action-handler";

import {LanguageMenuModuleController} from "../language-menu-module.controller";
import {LANGUAGE_MENU} from "../language-menu-module.consts";
import {CookieManager} from "../../../core/managers/cookie-manager";
import {LangSelectionClickEvent} from "../../../core/models/events/lang-selection-click-event";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {LanguageMenuModuleState} from "../models/language-menu-module.state";
// import {DEFAULT_CULTURE_NAME} from "../../../core/app/consts";
import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";
import {SESSION_STORAGE_KEYS} from "../../../core/consts";
import {SessionStorageUtils} from "../../../infrastructure/utils/session-storage.utils";

export class LanguageMenuModuleItemClickHandler extends ActionHandler {
  type = LANGUAGE_MENU.ACTION_TYPES.onItemClick;
  controller: LanguageMenuModuleController;
  cookieManager: CookieManager;
  analyticsService: AnalyticsService;
  state: LanguageMenuModuleState;

  static injectables = [...ActionHandler.injectables, CookieManager, AnalyticsService, SessionStorageUtils];

  constructor(cookieManager: CookieManager, analyticsService: AnalyticsService, sessionStorageUtils: SessionStorageUtils) {
    super();

    this.cookieManager = cookieManager;
    this.analyticsService = analyticsService;
    this.sessionStorageUtils = sessionStorageUtils;
  }

  async action(params) {
    const sourceLang: LanguageViewModel = this.state.appState.language;
    const targetLang: LanguageViewModel = params.language;

    this.cookieManager.updateCookieLangId(targetLang.id);
    const event: LangSelectionClickEvent = new LangSelectionClickEvent(this.controller.props.source, sourceLang, targetLang);
    this.analyticsService.createEvent(event);
    this.state.selectedLanguage = targetLang;

    this.sessionStorageUtils.set(SESSION_STORAGE_KEYS.topBookmaker, null);
    // this.changeLanguageRoute(targetLang);

    return true;
  }


  // changeLanguageRoute(selectedLanguage) {
  //   const currentCultureName = this.currentCultureName();
  //   const targetCultureName = this.targetCultureName(selectedLanguage);
  //   const currentUrl: String = this.controller.historyManager.currentPath;
  //   let targetUrl: String = currentUrl.replace(currentCultureName, targetCultureName);
  //
  //   if (targetUrl?.charAt(targetUrl.length - 1) === '/') {
  //     targetUrl = targetUrl.substr(0, targetUrl.length - 1);
  //   }
  //
  //   this.navigationManager.gotoUrl(targetUrl);
  // }

  // currentCultureName(): String {
  //   const currentCultureName = this.isDefaultCultureName() ? '/' : ('/' + this.state.currentLinkModel.cultureName);
  //
  //   return currentCultureName;
  // }
  //
  // targetCultureName(selectedLanguage): String {
  //   let targetCultureName: String = ''
  //   const isTargetDefaultCultureName: Boolean = selectedLanguage.displayName === DEFAULT_CULTURE_NAME;
  //
  //   if (!isTargetDefaultCultureName) {
  //     targetCultureName = this.isDefaultCultureName() ? selectedLanguage.linkModel.url + '/' : selectedLanguage.linkModel.url;
  //   }
  //
  //   return targetCultureName;
  // }

  // isDefaultCultureName(): Boolean {
  //   const isDefaultCultureName: Boolean = this.state.currentLinkModel.cultureName === DEFAULT_CULTURE_NAME;
  //
  //   return isDefaultCultureName;
  // }
}
